<template>
  <div class="main">
    <Header
      :show="true"
      title="新增卸料排队"
      left="prepage"
      :click-left="handleClickLeft"
    />
    <div class="content">
      <van-form
        ref="owdrForm"
        validate-first
        @submit="submit"
      >
        <van-field
          v-model="form.data.vehicleNo"
          name="vehicleNo"
          label="车牌号"
          placeholder="请输入"
          required
          :rules="[{ required: true, message: '请输入车牌号' }]"
        />
        <van-field
          name="materialType"
          label="物料类型"
          placeholder="请选择物料类型"
          :value="form.data.materialType"
          readonly
          clickable
          required
          :rules="[{ required: true, message: '请选择物料类型' }]"
          @click="form.showMaterialTypePicker = true"
        />
        <van-popup
          v-model="form.showMaterialTypePicker"
          position="bottom"
        >
          <van-picker
            show-toolbar
            :columns="pickerMaterialList"
            @confirm="handleConfirmMaterialType"
            @cancel="form.showMaterialTypePicker = false"
          />
        </van-popup>
        <van-field
          name="jarType"
          label="卸料口"
          placeholder="请选择物料类型"
          :value="form.data.jarType"
          readonly
          clickable
          required
          :rules="[{ required: true, message: '请选择卸料口' }]"
          @click="form.showJarTypePicker = true"
        />
        <van-popup
          v-model="form.showJarTypePicker"
          position="bottom"
        >
          <van-picker
            show-toolbar
            :columns="form.jarTypeList"
            @confirm="handleConfirmJarType"
            @cancel="form.showJarTypePicker = false"
          />
        </van-popup>

        <div
          v-if="checkPermission([492])"
          style="margin: 0.6rem 1rem"
        >
          <van-button
            round
            block
            type="info"
            native-type="submit"
          >
            确定
          </van-button>
        </div>
      </van-form>
    </div>
    <Footer value="service" />
  </div>
</template>
<script>
import Header from "@/views/components/header/index.vue";
import Footer from "@/views/components/footer/index.vue";

import { showPhoneAlarm } from "@/global/function.js";
import checkPermission from "@/utils/permission";
import { Dialog } from "vant";

import { add as updateOne } from "@/api/unloading.js";
import { getList } from "@/api/material";

export default {
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      query: {},
      supplierActivity: false,
      supplierList: [],
      materialList: [],
      form: {
        data: {
          supplier: "",
          grossWeight: 0,
          waterPercent: 0,
          vehicleType: "",
          materialType: "",
          busStatus: "1",
          quality: 5,
        },
        showVehiclePicker: false,
        vehicleTypeList: ["商砼货车", "罐装货车", "骨料货车"],
        showMaterialTypePicker: false,
        materialTypeList: ["商砼", "骨料", "粉料", "其他"],
        showMaterialPicker: false,
        showJarTypePicker: false,
        jarTypeList: ["1 号口", "2 号口"],
      },
    };
  },
  computed: {
    pickerMaterialList() {
      return this.materialList.filter(item => item.type === 1).map((item) => item.name);
    },
  },
  created() {
    const row = this.$route.query;
    this.query = row;
    this.form.data = {
      ...row,
      quality: +row.quality,
      qcPhotoList: row.qcPhotoUrl ? [{ url: row.qcPhotoUrl }] : [],
      busStatus: "1",
    };

    this.getMaterialList();
  },
  methods: {
    checkPermission,
    getMaterialList() {
      getList({ page: 1, limit: 1000 }).then(({ data: { data } }) => {
        const { items = [] } = data;
        this.materialList = items;
      });
    },
    handleClickLeft() {
      this.$router.go(-1);
    },
    async handleConfirmMaterialType(value) {
      this.form.data.materialType = value;
      this.form.showMaterialTypePicker = false;
    },
    handleConfirmJarType(value) {
      this.form.data.jarType = value;
      this.form.showJarTypePicker = false;
    },
    async submit() {
      const { jarType, materialType, vehicleNo } = this.form.data;
      const payload = {
        vehicleNo: vehicleNo,
        jarType: this.form.jarTypeList.indexOf(jarType) + 1,
        materialsType: materialType,
        materialsName: materialType,
      };

      this.loading = true;

      await Dialog.confirm({
        title: "确认新增卸料排队？",
        message: "车牌号：" + payload.vehicleNo,
        theme: "round-button",
      }).catch(() => {
        showPhoneAlarm(
          true,
          "toast",
          "success",
          2000,
          200,
          "新增卸料排队取消",
          "取消"
        );
        throw "新增卸料排队取消";
      });

      const { data } = await updateOne(payload).finally(() => {
        this.loading = false;
      });

      if (
        showPhoneAlarm(
          true,
          "toast",
          null,
          2000,
          data.code,
          "新增卸料排队",
          data.msg
        )
      ) {
        this.$router.push({
          path: "/service/business/unloading-queue",
          query: {},
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  padding-bottom: 80px;
}
.supplier-edit-wrap {
  position: relative;

  .supplier-autocomplete {
    position: absolute;
    background-color: #fff;
    max-height: 230px;
    overflow-y: auto;
    left: 0;
    right: 0;
    z-index: 100;
    box-shadow: 0 12px 24px 0 rgba(0, 0, 0, 0.06);

    ::v-deep .van-cell {
      font-size: 14px;
      padding: 12px 18px;
    }
  }
}
</style>
